<template>
  <div class="artist-select-wrapper" :class="{ active }">
    <div @click="active = true" class="dropdown">
      <div
        class="artist-image"
        v-if="artist.avatar_url && !imageErrors[artist.id]"
      >
        <img
          :src="artist.avatar_url"
          :alt="artist.name[0].toUpperCase()"
          @error="onImageError(artist.id)"
        />
      </div>
      <div class="artist-image-placeholder" v-else>
        {{ artist.name[0].toUpperCase() }}
      </div>

      <!-- <div class="artist-image">
        <img
          v-if="!imageErrors[artist.id] && loadedImages[artist.id]"
          :src="artist.avatar_url"
          :alt="artist.name[0].toUpperCase()"
          @error="onImageError(artist.id)"
          @load="onImageLoad(artist.id)"
        />
        <div class="artist-image-placeholder" v-else>
          {{ artist.name[0].toUpperCase() }}
        </div>
      </div> -->

      <div class="artist-name">
        <span>{{ artist.name }}</span>
      </div>
      <div class="dropdown-icon">
        <ChevronDownIcon />
      </div>
    </div>
    <div v-show="active" class="dropdown-menu">
      <div class="search default-input">
        <input
          type="text"
          placeholder="Search for an artist"
          v-model="searchQuery"
        />
      </div>
      <span class="switch-to-text">
        Switch to
      </span>
      <div class="artists">
        <div
          v-for="artist in results"
          :key="artist.id"
          @click="switchArtist(artist.id)"
          class="artist"
        >
          <div
            class="artist-image"
            v-if="artist.avatar_url && !imageErrors[artist.id]"
          >
            <img
              :src="artist.avatar_url"
              :alt="artist.name[0].toUpperCase()"
              @load="onImageLoad(artist.id)"
              @error="onImageError(artist.id)"
            />
          </div>
          <div class="artist-image-placeholder" v-else>
            {{ artist.name[0].toUpperCase() }}
          </div>
          <div class="artist-name">
            <span>{{ artist.name }}</span>
          </div>
        </div>
      </div>
      <div
        v-if="showSuspendedArtistsDropdown"
        @click="toggleSuspendedArtists"
        class="suspended-dropdown"
      >
        <span class="suspended-artists-text">
          Suspended
        </span>
        <div class="dropdown-icon">
          <ChevronDownIcon />
        </div>
      </div>
      <div v-if="showSuspendedArtists" class="artists suspended">
        <div
          v-for="artist in suspendedArtists"
          :key="artist.id"
          @click="switchArtist(artist.id)"
          class="artist"
        >
          <div class="artist-image">
            <img :src="artist.avatar_url" alt="artist logo" />
          </div>
          <div class="artist-name">
            <span>{{ artist.name }}</span>
          </div>
        </div>
      </div>
      <div @click="addArtist" class="add-artist">
        <AddArtistIcon />
        <span>Add an Artist</span>
      </div>
    </div>
    <div v-if="active" @click="active = false" class="background-overlay"></div>
  </div>
</template>

<script>
import { S_ARTISTS } from "@/graphql";
import AddArtistIcon from "../../../public/img/icons/user-plus.svg";
import ChevronDownIcon from "../../../public/img/icons/chevron-down.svg";
export default {
  name: "artist-select-drowdown",
  components: {
    ChevronDownIcon,
    AddArtistIcon,
  },
  data() {
    const user = this.$store.getters.getUser;
    return {
      subscriptionUserId: user.master_account_id || user.id,
      artists: [],
      active: false,
      showSuspendedArtists: false,
      searchQuery: "",
      imageErrors: {},
      loadedImages: {},
    };
  },
  mounted() {
    this.checkArtistSubscription();
  },
  watch: {
    artist() {
      this.checkArtistSubscription();
    },
    artists(update) {
      const artist = update.filter((artist) => artist.id === this.artist.id)[0];
      return this.$store.dispatch("setArtist", artist || update[0]);
    },
    active() {
      this.searchQuery = "";
    },
  },
  computed: {
    artist() {
      return this.$store.getters.getArtist;
    },
    user() {
      return this.$store.getters.getUser;
    },
    suspendedArtists() {
      return this.selection.filter((x) => !this.subscriptionActive(x));
    },
    showSuspendedArtistsDropdown() {
      return !!this.suspendedArtists.length;
    },
    selection() {
      return this.artists.filter(
        (switch_artist) => switch_artist.id !== this.artist.id
      );
    },
    results() {
      return this.selection.filter((artist) =>
        artist.name.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    },
  },
  methods: {
    async switchArtist(artist_id) {
      const artist = this.artists.filter(
        (artist) => artist.id === artist_id
      )[0];
      await this.$store.dispatch("setArtist", artist);
      this.active = false;
    },
    async addArtist() {
      this.active = false;
      if (this.$route.name !== "AddArtist") {
        await this.$router.push({ name: "AddArtist" });
      }
    },
    toggleSuspendedArtists() {
      this.showSuspendedArtists = !this.showSuspendedArtists;
    },
    checkArtistSubscription() {
      if (
        !["agency", "family"].includes(this.user.plan) &&
        !this.artist.current_plan &&
        this.$route.name !== "Billing"
      ) {
        return this.$router.push({ name: "Billing" });
      }
    },
    onImageError(artistId) {
      this.$set(this.imageErrors, artistId, true);
    },
    onImageLoad(artistId) {
      this.$set(this.loadedImages, artistId, true);
    },
  },
  apollo: {
    $subscribe: {
      statsToday: {
        query: S_ARTISTS,
        variables() {
          return { user_id: this.subscriptionUserId };
        },
        result({ data }) {
          this.artists = data.artists;
          // this.artists.forEach((artist) => {
          //   this.$set(this.loadedImages, artist.id, false); 
          //   this.$set(this.imageErrors, artist.id, false);
          // });
          // this.artists = data.artists.map((artist) => ({
          //   ...artist,
          //   avatar_url: null
          // }));
          // this.artists = data.artists.map(artist => ({
          //   ...artist,
          //   avatar_url: "a.jpg"
          // }));
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
//@import "../../assets/scss/custom/abstracts/colors";
//@import "../../assets/scss/custom/abstracts/fonts";
/* .artist-select-wrapper {
} */
.artist-image-placeholder {
  width: 30px;
  height: 30px;
  background: $purple-dark;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4px;
  color: white;
  font-weight: bold;
  margin-right: 15px;
}
.dropdown {
  cursor: pointer;
  color: $text-type-1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 200px;
  &:hover {
    .artist-name {
      font-weight: bold;
    }
  }
  .artist-image {
    width: 30px;
    height: 30px;
    background: radial-gradient(
      43.97% 43.97% at 50% 51.18%,
      rgba(157, 83, 232, 0.01) 0%,
      rgba(157, 83, 232, 0.31) 35.94%,
      rgba(157, 83, 232, 0.01) 100%
    );
    border-radius: 3px;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      border-radius: 20px;
      width: 30px;
      height: 30px;
      object-fit: cover;
    }
  }
  .artist-name {
    margin-left: 10px;
    margin-right: 8px;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    color: white;
    flex: 1;
  }
  .dropdown-icon {
    display: flex;
    align-items: center;
    margin-left: 5px;
    svg {
      width: 14px;
      path {
        stroke: white;
      }
    }
  }
}
.dropdown-menu {
  z-index: 1000;
  display: flex;
  flex-direction: column;
  position: absolute;
  background: linear-gradient(
    241.25deg,
    rgba(41, 39, 85, 0.45) 4.4%,
    rgba(41, 39, 84, 0.85) 61.77%,
    rgba(27, 24, 66, 0.45) 119.94%
  );
  box-shadow: 0px 51px 69px rgba(23, 18, 43, 0.585739);
  backdrop-filter: blur(23px);
  border-radius: 10px;
  padding: 18px;
  margin: 10px 0;
  .search {
    margin-bottom: 15px;
  }
  .switch-to-text {
    /* 10/SemiBold */
    font-weight: 600;
    font-size: 10px;
    line-height: 12px;
    /* Text/type0 */
    color: $text-type-0;
  }
  .suspended-dropdown {
    display: flex;
    justify-content: space-between;
    margin-top: 12px;
    padding: 12px 0;
    cursor: pointer;
    &:hover {
      .suspended-artists-text {
        color: white;
      }
    }
    .suspended-artists-text {
      /* 10/SemiBold */
      font-weight: 600;
      font-size: 10px;
      line-height: 12px;
      /* Text/type0 */
      color: $text-type-0;
    }
    .dropdown-icon {
      display: flex;
      align-items: center;
      svg {
        width: 14px;
        path {
          stroke: white;
        }
      }
    }
  }
  .artists {
    margin-top: 18px;
    height: auto;
    max-height: calc(100vh - 360px);
    overflow-y: scroll;
    scrollbar-width: thin;
    scrollbar-color: $purple;

    &.suspended {
      margin: 12px 0;
      height: auto;
      max-height: 144px;
      .artist {
        .artist-name {
          /* Text/type0 */
          color: $text-type-0;
        }
      }
    }

    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      /* Purple */
      background: $purple;
      border-radius: 22px;
    }
    .artist {
      display: flex;
      align-items: center;
      margin-bottom: 18px;
      cursor: pointer;
      &:hover {
        .artist-name {
          font-weight: bold;
        }
      }

      &:last-child {
        margin-bottom: 0;
      }

      .artist-image {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 6px;
        margin-right: 12px;
        img {
          border-radius: 20px;
          width: 30px;
          height: 30px;
          object-fit: contain;
        }
      }
      .artist-name {
        /* 16/Regular */
        font-size: 16px;
        line-height: 24px;
        color: white;
        mix-blend-mode: normal;
      }
    }
  }
  .add-artist {
    display: flex;
    align-items: center;
    margin-top: 9px;
    padding: 12px;
    cursor: pointer;
    &:hover {
      span {
        font-weight: bold;
      }
    }
    span {
      margin-left: 17px;
      font-weight: 500;
      font-size: 14px;
      line-height: 17px;
      color: white;
    }
    svg {
      width: 24px;
      path {
        fill: white;
      }
    }
  }
}
.background-overlay {
  z-index: 999;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  cursor: unset;
  background: $purple-dark;
  opacity: 0.9;
  backdrop-filter: blur(10px) !important;
}

@media screen and (max-width: 1024px) {
  .dropdown {
    width: fit-content;
    .artist-name {
      display: none;
    }
    .artist-image {
      width: 35px !important;
      height: 35px !important;
      img {
        width: 35px !important;
        height: 35px !important;
      }
    }
  }
  .active {
    top: 7px;
    .artist-name {
      display: block;
    }
    .dropdown {
      padding: 10px;
    }

    .dropdown-menu {
      position: fixed;
      left: 0;
      right: 0;
      width: 96% !important;
      margin-left: 10px;
    }

    .sidebar-wrapper .artist-dropdown {
      right: 0;
      left: 0;
    }
  }
}

@media screen and (max-width: 1024px) {
  .active .dropdown-menu {
    width: 170%;
  }
}
</style>
